import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import Constants from "../../../Action/Constants";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { TableComponent } from "../../Partials/Table/TableComponent";
// import { SubscriptionIcon } from "../../Partials/Subscription/SubscriptionIcon";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Divider from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import * as ReactTooltip from "react-tooltip";
import Time from "../../../Time/Time";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import UnitsWillMount from "../../../Middleware/Middlewares/UnitsWillMount";
import FlatMap from "../../../Array/FlatMap"
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import { ChargeTemplateInterface } from "../../../Entity/Entities/Charge/ChargeTemplateInterface";
import PeriodContainer from "../../../Entity/Entities/Charge/Period/PeriodContainer";
import { TabsComponent } from "./TabsComponent";
import Memo from "../../Partials/Memo/Memo";
import UnitSpreadSheet from "./UnitSpreadSheet";
import AssignmentServiceStatusTypeContainer from "../../../Entity/Entities/Unit/ServiceStatus/AssignmentServiceStatusTypeContainer";
import Select from "../../Partials/Material/Select";
import UnitServiceStatusTypeContainer from "../../../Entity/Entities/Unit/ServiceStatus/UnitServiceStatusTypeContainer";
import { CoachNewUnitDialog } from "../../Partials/Dialog/CoachNewUnitDialog";
import CreateTaskDialog from "../../Partials/Dialog/CreateTaskDialog";
import { PageTransition } from "../../Partials/Spinner/PageTransition";

class Units extends Component {
  public noteField: null;
  protected selectedUnit: UnitInterface;

  protected middlewares: MiddlewareInterface[] = [
    UnitsWillMount
  ];

  public state = {
    isPromptOpen: false,
    entity: null,
    filter: this.props.component.unitsFilter,
    shownUnitsCount: Object.keys(this.props.units?.byId || {}).map((id) => this.props.units.byId[id]).filter(unit => unit.removed === false).length,
    unitsCount: Object.keys(this.props.units?.byId || {}).map((id) => this.props.units.byId[id]).filter(unit => unit.removed === false).length,
    showOnlyInactiveDeletingDialog: false,
    memoPopupOpen: false,
    note: "",
    currentUnit: null,
    currentTenant: "",
    currentActivityTemplate: null,
    isCreateTasksFromActivityTemplatePopupOpen: false,
    postProcessMessage: "",
    postProcessPopupOpen: false,
    anchorEl: null,
    assignmentServiceStatusFilter: 0,
    openCoachCreateNewUnit: false,
    isNewTaskPopupOpen: false,
    isSaving: false,
    archiveActive: false
  };

  constructor(public props) {
    super(props);
  }

  protected unitDelete = (unit: UnitInterface) => {
    this.props.dispatch({
      type: Constants.GLOBAL_UNIT_DELETE_START,
      payload: {
        unit: unit,
        propertyId: unit.propertyId
      }
    });
  }

  public onCloseUnitCoach = (unit) => {
    this.setState({
      openCoachCreateNewUnit: false
    })
    if (unit) {
      return this.redirect(`/app/unit/update/${unit?.id}`);
    }
  }

  public getFilteredUnits = (filter) => {
    let units = Object.keys(this.props.units?.byId || {}).map((id) => this.props.units.byId[id]).filter(unit => unit.removed === false);

    switch (filter) {
      case "all":
        break;
      case "empty":
        units = units.filter((unit: UnitInterface) => unit?.isEmpty);
        break;
      case "unpaid":
        units = units.filter((unit: UnitInterface) => unit?.isUnpaid || unit?.isPartlyUnpaid);
        break;
      case "ending":
        units = units.filter((unit: UnitInterface) => unit?.isEnding);
        break;
      case "rented":
        units = units.filter((unit: UnitInterface) => unit?.isRented);
        break;
      case "expiring":
        units = units.filter((unit: UnitInterface) => unit?.isExpiring);
        break;
      case "inactive":
        units = units.filter((unit: UnitInterface) => unit?.isInactive);
        break;
      default:
        break;
    }

    return units;
  }

  public getFilteredPropertyUnits = (propertyUnits, filter) => {
    let units = propertyUnits.filter(unit => unit.removed === false)
      .sort((unit1: UnitInterface, unit2: UnitInterface) => {
        if (unit1.unitNumber > unit2.unitNumber) {
          return 1;
        }

        if (unit1.unitNumber < unit2.unitNumber) {
          return -1;
        }

        return  0;
      });

    switch (filter) {
      case "all":
        break;
      case "empty":
        units = units.filter((unit: UnitInterface) => unit.isEmpty);
        break;
      case "unpaid":
        units = units.filter((unit: UnitInterface) => unit.isUnpaid || unit.isPartlyUnpaid);
        break;
      case "ending":
        units = units.filter((unit: UnitInterface) => unit.isEnding);
        break;
      case "rented":
        units = units.filter((unit: UnitInterface) => unit.isRented);
        break;
      case "expiring":
        units = units.filter((unit: UnitInterface) => unit.isExpiring);
        break;
      case "inactive":
        units = units.filter((unit: UnitInterface) => unit.isInactive);
        break;
      default:
        break;
    }

    switch (String(this.state.assignmentServiceStatusFilter)) {
      case String(0):
        if (filter !== "inactive") {
          units = units.filter((unit: UnitInterface) => unit?.unitServiceStatus?.id !== UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE"));
        }
        break;
      case "unitServiceStatusInactive":
        units = units.filter((unit: UnitInterface) => unit?.unitServiceStatus?.id === UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE"));
        break;
      case String(AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")):
        units = units.filter((unit: UnitInterface) => unit?.defaultAgencyFees?.length > 0 && unit?.defaultAgencyFees?.[0]?.assignmentServiceStatus === AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch") && unit?.unitServiceStatus?.id !== UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE"));
        break;
      case String(AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial")):
        units = units.filter((unit: UnitInterface) => unit?.defaultAgencyFees?.length > 0 && unit?.defaultAgencyFees?.[0]?.assignmentServiceStatus === AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial") && unit?.unitServiceStatus?.id !== UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE"));  
        break
      case String(AssignmentServiceStatusTypeContainer.pickIdFromLabel("Operational")):
        units = units.filter((unit: UnitInterface) => unit?.defaultAgencyFees?.length > 0 && unit?.defaultAgencyFees?.[0]?.assignmentServiceStatus === AssignmentServiceStatusTypeContainer.pickIdFromLabel("Operational") && unit?.unitServiceStatus?.id !== UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE"));
        break;
      case String(AssignmentServiceStatusTypeContainer.pickIdFromLabel("Financial")):
        units = units.filter((unit: UnitInterface) => unit?.defaultAgencyFees?.length > 0 && unit?.defaultAgencyFees?.[0]?.assignmentServiceStatus === AssignmentServiceStatusTypeContainer.pickIdFromLabel("Financial") && unit?.unitServiceStatus?.id !== UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE"));
        break;
      default:
        break;
    }

    if (this.state.archiveActive) {
      units = units.filter((unit: UnitInterface) => unit?.unitServiceStatus?.id === UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE"));
    }

    return units;
  }

  public openMemoPopup = (unit: UnitInterface) => {
    this.setState({
      currentUnit: unit, 
      note: unit.note, 
      memoPopupOpen: true, 
      anchorEl: null 
    });
  }
  public saveDraft = (message) => {
    this.setState({
    note: message,
  })}
  
  public saveReminder = (unit: UnitInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_UNIT_UPDATE_START,
        payload: {
          id: unit && unit.id,
          unit: {
            note: this.state.note
          },
        },
        onSuccess: () => this.setState({isSaving: false, memoPopupOpen: false}),
        onError: () => {
          this.setState({isSaving: false});

          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans("memo-can-not-be-longer-than-255"),
              type: "warning"
            }
          });
        }
      });
    });
  }

  public removeReminder = (unit: UnitInterface) => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_UNIT_UPDATE_START,
        payload: {
          id: unit && unit.id,
          unit: {
            note: ""
          }
        },
        onSuccess: () => this.setState({isSaving: false, memoPopupOpen: false}),
        onError: () => this.setState({isSaving: false})
      });
    });
  }

  public getTipText = (tip: string) => {
    const tipLength = 30;

    if (tip.length > tipLength) {
      return `${tip.slice(0, tipLength)}...`;
    }

    return tip;
  }

  public comparer = (a, b) => {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }

    return 0;
  }

  public renderUnpaidIcon = (unit: UnitInterface) => {
    let label: string = this.trans("unpaid");
    let labelStyles: any = {
      backgroundColor: "transparent"
    };

    if (unit.isUnpaid) {
      labelStyles.backgroundColor = "#F44336";
    }

    if (unit.isPartlyUnpaid) {
      labelStyles.backgroundColor = "#F5A623";
    }

    return (
      <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        <div
          className="list-label"
          style={labelStyles}
          onClick={e => {
            e.stopPropagation();

            this.props.dispatch({
              type: Constants.PAGE_UNIT_UPDATE_SWITCH_TAB,
              payload: {
                index: 1,
                unitId: unit && unit.id
              }
            });

            return this.redirect(`/app/unit/update/${unit && unit.id}?filterStatus=unpaid`);
          }}
        >
          {label}
        </div>
      </div>
    );
  }

  public renderNoAgencyFeesIcon = (unit: UnitInterface) => {
    let label: string = this.trans("label/no-agency-fee");
    let labelStyles: any = {
      backgroundColor: "#F44336"
    };

    return (
      <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        <div
          className="list-label"
          style={labelStyles}
          onClick={e => {
            e.stopPropagation();

            this.props.dispatch({
              type: Constants.PAGE_UNIT_UPDATE_SWITCH_TAB,
              payload: {
                index: 0,
                unitId: unit && unit.id
              }
            });

            return this.redirect(`/app/unit/update/${unit && unit.id}`);
          }}
        >
          {label}
        </div>
      </div>
    );
  }
  public renderTasksLabel = (unit: UnitInterface) => {
    let label: string = this.trans("tasks");
    let labelStyles: any = {
      backgroundColor: unit.countOfOverdueTasks ? "red" : "#00BCD4"
    };
    if (unit.countOfUnfinishedTasks) {
    return (
      <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        <div
          className="list-label"
          style={labelStyles}
          onClick={e => {
            e.stopPropagation();
            this.redirect(`/app/dashboard/tasks`);
          }}
        >
          {label}
        </div>
      </div>
    );
        }
  }

  public renderTasksIcon = (unit: UnitInterface) => {
    if (unit.countOfUnfinishedTasks) {
      return (
        <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
          <span
            data-tip={unit.countOfOverdueTasks ?
                        this.trans("page/unitlist-tooltip/taskicon-overdueunfinished", {
                          unfinished: unit.countOfUnfinishedTasks,
                          overdue: unit.countOfOverdueTasks
                        }) :
                        this.trans("page/unitlist-tooltip/taskicon-unfinished", {
                          unfinished: unit.countOfUnfinishedTasks
                        })
                     }
          >
            <div
              style={{color: unit.countOfOverdueTasks ? "red" : "#00BCD4"}}
              className="icon icon-ic-task"
              onClick={e => {
                e.stopPropagation();
                this.redirect(`/app/unit/update/${unit.id}/`);
              }}>
            </div>
          </span>
          <ReactTooltip place="bottom" />
        </div>
      );
    }
  }

  public renderUnitAlertIcon = (unit: UnitInterface) => {
    return (
      <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        <span>
          <span data-tip={this.getTipText(unit.note)}>
          <div className={`icon ${unit?.hasMemos ? "icon-ic-bookmark blue-onhover" : "icon-ic-memo"}`}
              onClick={e => {
                e.stopPropagation();
                this.openMemoPopup(unit);
              }}
            >
            </div>
          </span>
          <ReactTooltip place="bottom" />
        </span>
      </div>
    );
  }

  public renderUnitStatuses = (unit: UnitInterface) => {
    let label = "";
    let backgroundColor = "transparent";

    if (unit.isEmpty) {
      label = this.trans("empty");
      backgroundColor = "#F44336";
    }

    if (unit.isEnding) {
      label = this.trans("ending");
      backgroundColor = "#F5A623";
    }

    if (unit.isExpiring) {
      label = this.trans("expiring");
      backgroundColor = "#F5A623";
    }

    if (unit.isInactive) {
      label = this.trans("label-deactivate");
      backgroundColor = "#B2B2B2";
    }

    const styles = {
      backgroundColor: backgroundColor
    };

    if(!!label) {
      return (
        <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
          <div className="list-label" style={styles}>
            {label}
          </div>
        </div>
      );
    } else {
      return "";
    }
  }

  public renderUnitServiceStatuses = (unit: UnitInterface) => {
    if(!AssignmentServiceStatusTypeContainer.pickLabelFromId(unit?.defaultAgencyFees?.[0]?.assignmentServiceStatus)) {
      return;
    }
    
    let backgroundColor = "transparent";
    const label = this.trans(`assignment_service_status_type_${ AssignmentServiceStatusTypeContainer.pickLabelFromId(unit?.defaultAgencyFees?.[0]?.assignmentServiceStatus)?.toLowerCase()}`)

    if (label === "Inactive") {
      backgroundColor = "#F44336";
    } else {
      backgroundColor = "#B2B2B2";
    }

    const styles = {
      backgroundColor: backgroundColor
    };

    return (
      <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        <div className="list-label" style={styles}>
          {label}
        </div>
      </div>
    );
  }

  protected prompt = (entity: any): void => {
    this.setState({
      isPromptOpen: true,
      entity: entity
    });
  }

  public closePrompt = (): void => {
    this.setState({
      isPromptOpen: false
    });
  }

  public changeActiveStatus = (unit: UnitInterface) => {
    this.closeMenu();

    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_UNIT_SET_ACTIVE_START,
        payload: {
          active: unit.isInactive,
          unitId: unit && unit.id
        },
        onSuccess: () => {
          this.setState({
            isSaving: false
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public delete = (): void => {
    this.closePrompt();

    if (this.state.entity.nameOfEntity === this.trans("unit")) {
      return this.unitDelete(this.state.entity);
    }
  }

  public propertyComparer = (a, b) => {
    return this.comparer(a.address.formattedAddress, b.address.formattedAddress);
  }

  protected openMenu = (event: any, unit: UnitInterface): void => {
    this.selectedUnit = unit;

    this.setState({
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public getRows = () => {
    return Object.keys(this.props.properties?.byId || {}).map((id) => this.props.properties.byId[id])
      .filter((property: PropertyInterface) => property.removed === false)
      .sort(this.propertyComparer)
      .map((property: PropertyInterface) => {
        if (this.getFilteredPropertyUnits(property.units, this.state.filter).length === 0) {
          return [];
        }

        const propertyRow = [];

        if (!property) {
          return [];
        }

        const addressFirstPart = !property.address.fullAddress.route &&
                                 !property.address.fullAddress.streetNumber ?
                                  property.displayName :
                                   `${property.address.fullAddress.route ? property.address.formattedAddress?.split(",")?.[0] : ""}`;
        
        let addressSecondPart = !property.address.fullAddress.route &&
         !property.address.fullAddress.streetNumber ?
           "" :
           `${property.address.fullAddress.postalCode ? property.address.fullAddress.postalCode + ", " : ""}${property.address.fullAddress.locality ? property.address.fullAddress.locality : ""}`;
 
         addressSecondPart = addressSecondPart ? ", " + addressSecondPart : addressSecondPart;

        propertyRow.push(
          (
            <TableRow
              key={`property-${property.id}`}
              style={{height: "40px"}}
            >
              <TableCell style={{padding: "0"}}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    flexDirection: "row",
                    alignItems: "flex-end"
                  }}
                >
                  { property.complexName && (
                  <div style={{fontSize: "22px", marginRight: "5px"}}>
                    {property.complexName + ","}
                  </div>
                  )}
                  <div style={{fontSize: "22px"}}>
                    {addressFirstPart}
                  </div>
                  <div style={{color: "gray", fontSize: "18px", marginBottom: "2px"}}>
                    {addressSecondPart}
                  </div>
                </div>
              </TableCell>
              <TableCell style={{width: "25px"}}>
              </TableCell>
              <TableCell style={{width: "5px"}}>
              </TableCell>
              <TableCell>
              </TableCell>
            </TableRow>
          )
        );

        const unitRows = this.getFilteredPropertyUnits(property.units, this.state.filter)
          .map((unit: UnitInterface) => {
            if (!unit) {
              return;
            }

            const currentContract = unit.getActiveContract();

            let chargeTemplates;

            if (currentContract) {
              chargeTemplates = currentContract && currentContract.chargeTemplates.length > 0 && currentContract.chargeTemplates;
            } else {
              chargeTemplates = unit && unit.defaultChargeTemplates.length > 0 && unit.defaultChargeTemplates;
            }

            const monthlyChargeTemplatesAmount = chargeTemplates && [...chargeTemplates]
              .filter((chargeTemplate: ChargeTemplateInterface) => chargeTemplate?.repeatPeriod?.id === PeriodContainer.pickIdFromLabel("monthly"))
              .map((chargeTemplate: ChargeTemplateInterface) => chargeTemplate.amount)
              .reduce((a, b) => a + b, 0);

            const templatePrice = chargeTemplates && monthlyChargeTemplatesAmount ? ` ${this.formatter.formatNumber(monthlyChargeTemplatesAmount, this.props.app.settings.user.currency)}` : "";

            let unitDetails = unit.roomNumber ? `${unit.roomNumber} ${this.trans("room").toLowerCase()} /` : '';
            unitDetails = unit.squareMeters ? unitDetails + ` ${unit.squareMeters} m2 /` : unitDetails;
            unitDetails = templatePrice ? `${unitDetails + templatePrice}` : unitDetails.slice(0, -1);

            return (
              <TableRow
                hover
                key={`unit-${unit.id}`}
                className={`clickable-entity`}
                onClick={() => {
                  this.redirect(`/app/unit/update/${unit.id}`);
                }}
              >
                <TableCell>
                  <div style={{paddingLeft: "10px", paddingTop: "10px", display: "flex", justifyContent: "flex-start", flexDirection: "column"}}>
                    <div style={{display: "flex", justifyContent: "flex-start", flexDirection: "row"}}>
                      <div style={{display: "flex", alignItems: "center"}}>{unit.renderAvatar()}</div>
                      <div style={{display: "flex", justifyContent: "flex-start", flexDirection: "column", marginLeft: "10px"}}>
                        <div style={{display: "flex", justifyContent: "flex-start", flexDirection: "row", alignItems: "baseline"}}>
                          {
                            unit.unitNumber && (
                              <div style={{fontWeight: "bold"}}>
                                {`${unit.unitNumber}`}
                              </div>
                            )
                          }
                          <div style={{fontSize: "14px"}}>
                            <span className="unit-type-table" style={{fontWeight: "bold", marginLeft: unit.unitNumber ? '8px' : '0px'}}>{!!unit.type ? this.trans(unit.type.label) + '\xa0\xa0' : '\xa0\xa0'}</span>
                            <span style={{color: "gray", fontSize: "14px"}}>
                              {unitDetails}
                              {
                                unit.rentUpdateDate && (
                                  <span  style={{marginLeft: "5px", fontSize: "12px"}}>
                                    {`(${this.trans("page/unitlist-unit-info/templateupdatedate", {date: this.formatter.formatDate(unit.rentUpdateDate)})})`}
                                  </span>
                                )
                              }
                            </span>
                          </div>
                        </div>
                        <div style={{fontSize: "14px"}}>
                          {!unit.isEmpty && (
                            <div style={{display: "flex", justifyContent: "flex-start", color: "#6f6f6f"}}>
                              {(unit.getActiveContract()?.person || unit.getActiveContract()?.person?.company) && <div style={{fontWeight: "bold"}}>{`${unit.getActiveContract()?.person ? unit.getActiveContract()?.person?.displayName : ""}${unit.getActiveContract()?.person?.company ? ` (${unit.getActiveContract()?.person?.company?.displayName})` : ""}`}</div>}
                              <div style={{display: "flex"}}>{unit?.getTenantAndOccupantsForUnitList()?.map(elem => {
                                return (
                                  <span>{`${elem?.person ? `, ${elem?.person?.displayName}` : ""}${elem?.person?.company ? ` (${elem?.person?.company?.displayName})` : ""}`}</span>
                                );
                              })}
                              </div>
                            </div>
                          )}
                          <div style={{display: "flex", justifyContent: "flex-start", alignItems: "center", height: "30px"}}>
                            {!!this.renderUnitStatuses(unit) && <span style={{paddingRight: "10px", color: "red"}}>{this.renderUnitStatuses(unit)}</span>}
                            {!!this.renderUnitServiceStatuses(unit) && <span style={{paddingRight: "10px", color: "yellow"}}>{this.renderUnitServiceStatuses(unit)}</span>}
                            {(unit.isUnpaid || unit.isPartlyUnpaid) && <span style={{paddingRight: "10px", color: "orange"}}>{this.renderUnpaidIcon(unit)}</span>}
                            {!unit.existsActiveAgencyFees && <span style={{paddingRight: "10px", color: "green"}}>{this.renderNoAgencyFeesIcon(unit)}</span>}
                            {!!unit.countOfUnfinishedTasks && <span style={{paddingRight: "10px"}}>{this.renderTasksLabel(unit)}</span>}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{display: "flex", justifyContent: "space-between", flexDirection: "row", padding: "10px 0  0 0"}}>
                      {
                        unit.planningDataNormalized.map((color, index) => {
                          return (
                            <div key={`planning-color-${index}-${unit.id}`} style={{height: "6px", backgroundColor: unit.isInactive ? "#B2B2B2" : color, flexGrow: 1}}></div>
                          )
                        })
                      }
                    </div>
                    <div style={{display: "flex", justifyContent: "space-between", flexDirection: "row", padding: "5px 0 15px 0"}}>
                      {
                        Time.getTwelveMonths(new Date()).map((month, index) => {
                          return (
                            <div key={`planning-month-${index}-${unit.id}`} style={{height: "10px", flexGrow: 1, color: "darkgray", fontSize: "12px"}}>{month.toUpperCase()}</div>
                          )
                        })
                      }
                    </div>
                  </div>
                </TableCell>
                {/* <TableCell style={{width: "25px", paddingTop: "10px", verticalAlign: "top"}}>
                  {this.renderTasksIcon(unit)}
                </TableCell> */}
                <TableCell style={{width: "5px", paddingTop: "10px", verticalAlign: "top"}}>
                  {this.renderUnitAlertIcon(unit)}
                </TableCell>
                <TableCell
                  style={{verticalAlign: "top"}}
                  onClick={e => {
                    e.stopPropagation();
                  }}
                >
                  <div>
                    <IconButton
                      onClick={e => this.openMenu(e, unit)}
                    >
                      <div className="icon icon-ic-more-vert"></div>
                    </IconButton>
                    <Menu
                      id="simple-menu"
                      anchorEl={this.state.anchorEl}
                      open={Boolean(this.state.anchorEl) && this.selectedUnit && this.selectedUnit.id === unit.id}
                      onClose={this.closeMenu}
                      disableAutoFocusItem={true}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center"
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left"
                      }}
                      getContentAnchorEl={null}
                    >
                      <MenuItem
                        key={`edit-btn`}
                        onClick={() => {
                          this.redirect(`/app/unit/update/${this.selectedUnit.id}`)
                        }}
                      >
                        <ListItemIcon><div className="icon icon-ic-edit aligned"></div></ListItemIcon>
                        <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                      </MenuItem>
                      {/* <MenuItem
                        key={`de-activate-btn`}
                        onClick={() => this.changeActiveStatus(this.selectedUnit)}
                      >
                        <ListItemIcon><div className="icon icon-ic-activate aligned"></div></ListItemIcon>
                        <ListItemText>{this.selectedUnit && !this.selectedUnit.isInactive ? this.trans("menuitem-deactivate") : this.trans("menuitem-activate")}</ListItemText>
                      </MenuItem> */}
                      <MenuItem
                        key={`delete-btn`}
                        className="delete-action"
                        onClick={() => {
                          this.setState({
                            entity: unit,
                            isPromptOpen: true,
                            anchorElUnits: null
                          });
                        }}
                      >
                        <ListItemIcon><div className="icon icon-ic-remove aligned"></div></ListItemIcon>
                        <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                      </MenuItem>
                      <Divider/>
                      <MenuItem
                        key={`add-task-btn`}
                        onClick={() => this.setState({isNewTaskPopupOpen: true})}
                      >
                        <ListItemIcon><div className="icon icon-ic-task aligned"></div></ListItemIcon>
                        <ListItemText>{this.trans("menuitem-create-task")}</ListItemText>
                      </MenuItem>
                      <MenuItem
                        key={`add-memo-btn`}
                        onClick={() => this.openMemoPopup(this.selectedUnit)}
                      >
                        <ListItemIcon><div className="icon icon-ic-memo aligned"></div></ListItemIcon>
                        <ListItemText>{this.trans("menuitem-open-memo")}</ListItemText>
                      </MenuItem>
                      {this.props.app.activityTemplates.filter(activityTemplate => !activityTemplate.removed).length > 0 && this.props.app.settings.agency.isActivitiesShown && (<Divider/>)}
                      {this.props.app.activityTemplates.filter(activityTemplate => !activityTemplate.removed).length > 0 && this.props.app.settings.agency.isActivitiesShown &&
                       <div
                          style={{
                            padding: "14px 16px",
                            fontSize: "12px", color: "gray",
                            outline: "0",
                            userSelect: "none"
                          }}
                        >{this.trans("menuitem-activities")}</div>}
                      {
                        this.props.app.activityTemplates.filter(activityTemplate => !activityTemplate.removed).length > 0 && this.props.app.settings.agency.isActivitiesShown && (
                          this.props.app.activityTemplates.filter(activityTemplate => !activityTemplate.removed).map((activityTemplate, key: number) => {
                            return (
                              <MenuItem
                                key={`activity-${key}`}
                                onClick={() => this.setState({isCreateTasksFromActivityTemplatePopupOpen: true, currentUnit: this.selectedUnit, currentActivityTemplate: activityTemplate, currentTenant: this.selectedUnit.getActiveContract() && this.selectedUnit.getActiveContract().person && this.selectedUnit.getActiveContract().person.displayName, anchorEl: null})}
                              >
                                <ListItemIcon><div className="icon icon-ic-activity aligned"></div></ListItemIcon>
                                <ListItemText>{activityTemplate.name}</ListItemText>
                              </MenuItem>
                            )
                          })
                        )
                      }
                    </Menu>
                  </div>
                </TableCell>
              </TableRow>
            );
          });

        return [...propertyRow, ...unitRows];
      });
  }

  public changeAssignmentServiceStatusFilter = (event) => {
    const type: number = event.target.value;

    this.setState({
      assignmentServiceStatusFilter: type
    });
  }

  public changeUnitStatusFilterServiceStatus = (event) => {
    const filter = event.target.value;
    const unitsCount = this.getFilteredUnits(filter).length;
    const shownUnitsCount = this.props.app.paginator.Units && this.props.app.paginator.Units > unitsCount ?
      unitsCount : this.props.app.paginator.Units;

    this.props.dispatch({
      type: Constants.PAGE_UNITS_UNITS_FILTER,
      payload: {
        filter: filter
      }
    });

    this.setState({
      filter: filter,
      shownUnitsCount: shownUnitsCount,
      unitsCount: unitsCount
    });
  }

  public handleChangeArchive = () => {
    this.setState({
      archiveActive: !this.state.archiveActive,
      // When the archive is active, we ignore service filterer, when inactive, we set back "all".
      assignmentServiceStatusFilter: this.state.archiveActive ? 0 : "ignore",
      filter: "all"
    })
  }

  public render() {
    const units = Object.keys(this.props.units?.byId || {}).map((id) => this.props.units.byId[id]);

    return (
      <div className="state-app">
        <div className={`box box-full component-properties has-general-page-header with-tabs bottom-whitespace ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
          <div className="component-header no-paddings">
            <div style={{padding: "0 40px", display: "flex", justifyContent: "space-between"}}>
              <h1 style={{padding: "24px 0"}}>{this.trans("title-units")}</h1>
              <div className="button-container">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.setState({
                    openCoachCreateNewUnit: true
                  })}
                >
                  {this.trans("button-add-unit")}
                </Button>
              </div>
            </div>
            <TabsComponent
              {...this.props}
              activeTab={0}
            />
          </div>

          <div className="component-wrapper no-margin-top">
            <div style={{padding: "10px", display: "flex", justifyContent: "space-between"}}>
              <div>
                {!this.state.archiveActive &&
                <Select
                  style={{width: "220px", marginRight: "20px"}}
				          className="form-element form-input scroll-to-unitTypeId correct-label-position"
				          error={this.getErrorFor("assignmentServiceStatusId")}
				          value={this.state.filter}
				          onChange={this.changeUnitStatusFilterServiceStatus}
				          htmlFor="assignmentServiceStatusId"
				          label={this.trans("title-units")}
				        >    
                  <MenuItem key={0} value={"all"} className="assignment-service-status-type-el">{`${this.trans("all")} (${this.getFilteredPropertyUnits(units, "all").length})`}</MenuItem>
                  <MenuItem key={1} value={"empty"} className="assignment-service-status-type-el">{`${this.trans("empty")} (${this.getFilteredPropertyUnits(units, "empty").length})`}</MenuItem>
                  <MenuItem key={2} value={"ending"} className="assignment-service-status-type-el">{`${this.trans("ending")} (${this.getFilteredPropertyUnits(units, "ending").length})`}</MenuItem>
                  <MenuItem key={3} value={"expiring"} className="assignment-service-status-type-el">{`${this.trans("expiring")} (${this.getFilteredPropertyUnits(units, "expiring").length})`}</MenuItem>
                  <MenuItem key={4} value={"rented"} className="assignment-service-status-type-el">{`${this.trans("rented")} (${this.getFilteredPropertyUnits(units, "rented").length})`}</MenuItem>
                  <MenuItem key={5} value={"inactive"} className="assignment-service-status-type-el">{`${this.trans("label-deactivate")} (${this.getFilteredPropertyUnits(units, "inactive").length})`}</MenuItem>
                  <MenuItem key={6} value={"unpaid"} className="assignment-service-status-type-el">{`${this.trans("unpaid")} (${this.getFilteredPropertyUnits(units, "unpaid").length})`}</MenuItem>
				        </Select>
                }
                {!this.state.archiveActive &&
                <Select
                  style={{width: "220px"}}
				          className="form-element form-input scroll-to-unitTypeId correct-label-position"
				          error={this.getErrorFor("assignmentServiceStatusId")}
				          value={this.state.assignmentServiceStatusFilter}
				          onChange={this.changeAssignmentServiceStatusFilter}
				          htmlFor="assignmentServiceStatusId"
				          label={this.trans("page/unitupdate-section/info-changeunitservicestatus/label")}
				          name="assignmentServiceStatus" 
				          id="assignmentServiceStatus"
				        >
                  <MenuItem key={0} value={0} className="assignment-service-status-type-el">{this.trans("all")}</MenuItem>
                  <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(2).toLowerCase()}`)}</MenuItem>
                  <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(5).toLowerCase()}`)}</MenuItem>
                  <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Financial")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Financial")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(4).toLowerCase()}`)}</MenuItem>
                  <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Operational")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Operational")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(3).toLowerCase()}`)}</MenuItem>
                  {/* <MenuItem key={"unitServiceStatusInactive"} value={"unitServiceStatusInactive"} className="assignment-service-status-type-el">{this.trans("unit_service_status_type_inactive")}</MenuItem> */}
				        </Select>
                }
              </div>
              <div style={{display: "flex"}}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.archiveActive}
                      onChange={this.handleChangeArchive}
                      color="primary"
                    />
                    }
                  label={this.trans("label-archive")}
                />

                <div style={{display: "flex", alignItems: "center", padding: "6px 5px 0 5px", cursor: "pointer"}}>
                  <div 
                    className="icon icon-style-launch-panel icon-ic-download" 
                    onClick={() => UnitSpreadSheet.download(Object.keys(this.props.units?.byId || {})?.map((id) => this.props.units.byId[id]))}
                  >
                  </div>
                </div>
              </div>
            </div>

            <TableComponent
              {...this.props}
              paginator={{
                name: "Units",
                path: this.props.app.paginator
              }}
              className="listing-table property-unit-listing-table"
              isFetched={this.props.app.loadedEntities.includes(Constants.GLOBAL_UNIT_LIST_SUCCESS)}
              rows={[...FlatMap.flatMap(this.getRows(), row => [...row])]}
              subtitle={this.trans("title-no-units-to-list")}
              noPagination={true}
            />
          </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("memo")}
          content={
            <div>
              <Memo 
                {...this.props}
                entity={this.state.currentUnit}
                saveDraft={this.saveDraft}
                relations={{ unitId: this.state.currentUnit?.id }}
              />
            </div>
          }
          prioritizeClosing={true}
          openLeavePrompt={this.state.memoPopupOpen}
          onlyPositiveButton={true}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.saveReminder(this.state.currentUnit)}
          hideCross={true}
          subtitle={this.state.currentUnit && this.state.currentUnit.displayName ?
            this.state.currentUnit.displayName : ""}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("create-tasks-for", {activityTemplate: this.state.currentActivityTemplate ? this.state.currentActivityTemplate.name : ""})}
          content={this.trans("you-are-about-to-create-task-for-activity-for-unit", {activityTemplate: this.state.currentActivityTemplate ? this.state.currentActivityTemplate.name : "", tenant: this.state.currentTenant, unit: this.state.currentUnit && this.state.currentUnit.displayName ? this.state.currentUnit.displayName : ""})}
          openLeavePrompt={this.state.isCreateTasksFromActivityTemplatePopupOpen}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("create-tasks")}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isCreateTasksFromActivityTemplatePopupOpen: false }); }}
          onSave={() => { this.setState({ isCreateTasksFromActivityTemplatePopupOpen: false }, () => {
            this.props.dispatch({
              type: Constants.PAGE_ACTIVITY_CREATE_ADD_PARAMS,
              payload: {
                unitId: this.state.currentUnit && this.state.currentUnit.id
              }
            });

            this.redirect(`/app/activity/create/${this.state.currentActivityTemplate && this.state.currentActivityTemplate.id}/0/${this.state.currentUnit && this.state.currentUnit.id}`);
          })}}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("email-was-changed")}
          content={(<p>{this.state.postProcessMessage}</p>)}
          positiveButtonLabel={this.trans("button-close")}
          onlyPositiveButton={true}
          openLeavePrompt={this.state.postProcessPopupOpen}
          prioritizeClosing={true}
          onSave={() => {
            this.setState({ postProcessPopupOpen: false });
          }}
        />

        <CoachNewUnitDialog
          {...this.props}
          openCoachCreateNewUnit={this.state.openCoachCreateNewUnit}
          onCloseUnitCoach={this.onCloseUnitCoach}
          // openPropertyCoachDialog={this.openPropertyCoachDialog}
          // openCoachNewContract={this.openCoachNewContract}

          // propertyCreateByCoach={this.state.propertyCreateByCoach}
          // openUnitCoachDialogForAgencyCoach={this.state.openUnitCoachDialogForAgencyCoach}
        />

        <DeleteEntityPrompt
          {...this.props}
          isOpen={this.state.isPromptOpen}
          onCancel={this.closePrompt}
          onDelete={this.delete}
        />

        <CreateTaskDialog 
          {...this.props}
          entity={this.selectedUnit}
          isOpen={this.state.isNewTaskPopupOpen}

          closeDialog={() => {
            this.setState({
              isNewTaskPopupOpen: false,
              isSaving: false, 
              anchorEl: null
            })
          }}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    properties: state.properties,
    units: state.units,
    component: state.unitsPage,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  Units
);
